
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/legal",
      function () {
        return require("private-next-pages/services/legal.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/legal"])
      });
    }
  